import { User } from 'src/app/models/user.model';
import { Questao } from './../models/mentoria.model';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { firestore } from 'firebase/app';
import { map, switchMap, shareReplay } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs';
import { AuthService } from './auth.service';
import { Resposta } from '../models/mentoria.model';
import { UserProfile } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class MentoriaService {

  constructor(
    private db: AngularFirestore,
    private auth: AuthService,
    private router: Router
  ) { }

  // Busca o a resposta da questao/topico discutido pelo id dele
  getResposta(questaoID: string) {
    return this.db
    .collection<Resposta>('resposta')
    .doc(questaoID)
    .snapshotChanges()
    .pipe(
      map(doc => {
        const data = doc.payload.data() as Resposta;
        const id = doc.payload.id;
        return { id, ...data };
      }),
      shareReplay(1)
    );
  }

  // Busca o a questao/topico discutido pelo id dele
  getQuestao(questaoID: string) {
    return this.db
    .collection<Questao>('questao')
    .doc(questaoID)
    .snapshotChanges()
    .pipe(
      map(doc => {
        const data = doc.payload.data() as Questao;
        const id = doc.payload.id;
        return { id, ...data };
      })
    );
  }

  async getQuestoesList(hackathonId) {
    return this.db
    .collection<any>('questao')
    .ref
    .where('hackathonId', '==', hackathonId)
    .get();
  }

  // cria uma nova questao no forum
  async criarQuestaoTopicoNoforum(uid, nome, pergunta, detalhesPergunta, hackthonID) {

    const data = {
      userId: uid,
      userDisplayName: nome,
      questao: pergunta,
      descricao: detalhesPergunta,
      hackathonId: hackthonID
    };
    await this.db.collection('questao').add(data)
    .then(questao => {
      this.create(questao.id);
    });
  }

  // Cria uma resposta na questao
  async create(questaoID) {
    const user = await this.auth.getUser;
    const uid = user.user.uid;

    const data = {
      uid,
      createdAt: Date.now(),
      count: 0,
      respostas: []
    };

    await this.db.doc(`resposta/${questaoID}`).set(data);
    return this.router.navigate(['hackathon/topico', questaoID]);
  }

  async sendMessage(questaoID, resposta) {
    const user: any = await this.auth.getUser;
    const uid = user.user.uid;

    const data = {
      uid,
      resposta,
      createAt: Date.now(),
      time: new Date().toUTCString()
    };

    const ref = this.db.collection('resposta').doc(questaoID);

    return ref.update({
      respostas: firestore.FieldValue.arrayUnion(data)
    });
  }

  joinUsers(questao$: Observable<any>) {
    let resposta;
    const joinKeys = {};

    return questao$.pipe(
      switchMap(c => {
        // Unique User IDs
        resposta = c;
        const uids = Array.from(new Set(c.respostas.map(v => v.uid)));

        // Firestore User Doc Reads
        const userDocs = uids.map(u =>
          this.db.doc(`users/${u}`).valueChanges().pipe(shareReplay(1))
        );

        return userDocs.length ? combineLatest(userDocs) : of([]);
      }),
      map(arr => {
        // converte userData para userProfile
        arr.forEach((userData: User) => joinKeys[( userData as any ).user.uid] = userData.user);

        resposta.respostas = resposta.respostas.map(userData => {
          return { ...userData, user: joinKeys[userData.uid] };
        });

        return resposta;
      })
    );
  }
}
